import React, { useState } from 'react';
import Datatable from '../../components/shared/datatable/Datatable';
import { formatDateToMDY, showToast } from '../../helpers/Utils';
import { useGetAllProductsQuery, useDeleteProductMutation } from '../../app/offerApi/OfferApi';
import { Image } from 'react-bootstrap';
import Button from '../../components/shared/buttons/button';
import { MdOutlineEditNote } from 'react-icons/md';
import { MdDeleteOutline } from 'react-icons/md';
import AddOfferModal from '../../components/shared/modalContent/AddOfferModal';
import CommonDeleteModal from '../../components/shared/modalContent/CommonDeleteModal';
import { PhotoProvider, PhotoView } from 'react-photo-view';
import { AiOutlineEye } from 'react-icons/ai';
import { useNavigate } from 'react-router';
const Offers = () => {
    const navigate = useNavigate()
    const [page, setPage] = useState(1);
    const [search, setSearch] = useState('');
    const [showAddOfferModal, setShowAddOfferModal] = useState(false);
    const [showCommonDeleteModal, setShowCommonDeleteModal] = useState(false);
    const [prodcutId, setProductId] = useState(null)
    const { data, isLoading, refetch } = useGetAllProductsQuery({ page, search });
    const [deleteProduct, { isLoading: isDeleting }] = useDeleteProductMutation();

    const handlePageChange = (newPage) => {
        setPage(newPage);
    };

    const handleSearch = (value) => {
        setSearch(value);
    };



    const handleDelete = async () => {
        try {
            await deleteProduct(prodcutId).unwrap();
            setShowCommonDeleteModal(false)
            refetch();
        } catch (error) {
            showToast(error?.data?.message || 'Something went wrong', 'error');
        }
    };

    const columns = [
        {
            label: 'Image',
            accessor: 'product_image',
            cell: ({ row }) => (
                <PhotoProvider>
                    <PhotoView src={row?.product_image}>
                        <Image
                            src={row?.product_image}
                            alt={row?.product_name}
                            width={60}
                            height={60}
                            rounded
                        />
                    </PhotoView>

                </PhotoProvider>
            ),
        },
        {
            label: 'Product Name',
            accessor: 'product_name',
        },
        {
            label: 'Brand',
            accessor: 'brand',
        },
        {
            label: 'Price',
            accessor: 'product_price',
            cell: ({ row }) => `£${row?.product_price}`,
        },
        {
            label: 'Discount',
            accessor: 'discount',
            cell: ({ row }) =>
                row?.discount ? `${row?.discount_percentage}%` : 'No Discount',
        },
        {
            label: 'Description',
            accessor: 'product_description',
               cell: ({ row }) =>{return(
                <span className='ellipse'>{row?.product_description}</span>
               )},
        },
        {
            label: 'Created At',
            accessor: 'createdAt',
            cell: ({ row }) => formatDateToMDY(row?.createdAt),
        },
        {
            label: 'Action',
            accessor: 'action',
            cell: ({ row }) => (
                <div className='d-flex gap-3'>
                    <Button
                        className={'borderedBtn px-0'}
                        size="xs"
                        icon={<MdOutlineEditNote size={20} />}
                        onClick={() => { setProductId(row?._id); setShowAddOfferModal(true) }}
                    />
                    <Button
                        className={'borderedBtn px-0'}
                        size="xs"
                        icon={<MdDeleteOutline size={20} />}
                        onClick={() => { setProductId(row?._id); setShowCommonDeleteModal(true) }}
                        disabled={isDeleting}
                    />
                    <Button
                        className={'borderedBtn px-0'}
                        size="xs"
                        icon={<AiOutlineEye size={20} />}
                        onClick={() => { navigate(`/home/product-details/${row?._id}`) }}
                        disabled={isDeleting}
                    />
                </div>
            ),
        },
    ];

    return (
        <>
            <CommonDeleteModal show={showCommonDeleteModal} setShow={setShowCommonDeleteModal} onSucces={handleDelete} title={'Are you sure you want to delete this Product'} />
            <AddOfferModal
                prodcutId={prodcutId}
                show={showAddOfferModal}
                setShow={setShowAddOfferModal}
                onSuccess={() => {
                    setShowAddOfferModal(null);
                    refetch();
                }}
            />

            <div className='d-flex gap-3 justify-content-between align-items-center mb-3'>
                <h5 className='home-title'>Offers</h5>
                <Button
                    label={'Create Offer'}
                    onClick={() => {
                        setProductId(null);
                        setShowAddOfferModal(true);
                    }}
                />
            </div>

            <Datatable
                tableData={data?.data || []}
                columns={columns}
                page={page}
                onPageChange={handlePageChange}
                isLoading={isLoading}
                showPegination={true}
                showFilter={false}
                onFilterSearch={handleSearch}
            />
        </>
    );
};

export default Offers;
